import type { ComponentType } from 'react';

export interface BadgeProps {
  text?: string;
  icon?: ComponentType<{ className?: string; 'aria-hidden'?: boolean }>;
  className?: string;
  textClassName?: string;
}

export function Badge({ text, icon: Icon, className, textClassName }: BadgeProps) {
  if (!text) return null;

  return (
    <div
      className={[
        'flex flex-row items-center justify-center gap-2 rounded bg-[var(--content-green-lightest)] px-3 py-2',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {Icon ? <Icon aria-hidden className="size-6 text-[var(--content-green-dark)]" /> : null}
      <span
        className={['typography-text-bold text-[var(--content-green-dark)]', textClassName]
          .filter(Boolean)
          .join(' ')}
      >
        {text}
      </span>
    </div>
  );
}
